import {Injectable} from '@angular/core';
import {ProductParameterInnerState, Store as ProductParameterInnerStore} from './store';
import {EntityService} from '../../../components/entity-service';
import {ProductParameterInner} from './model';
import {FieldConfig} from '../../../components/form/field.interface';
import {Validators} from '@angular/forms';
import {TranslocoService} from '@ngneat/transloco';
import {map, shareReplay, switchMap} from 'rxjs/operators';
import {ProductParameterInnerQuery} from './query';

@Injectable({ providedIn: 'root' })
export class ProductParameterInnerService extends EntityService<ProductParameterInnerStore, ProductParameterInnerState> {

  productParameterInners$ = this.get().pipe(
    switchMap(() => this.query.selectAll()),
    map(items => items.map(item => new ProductParameterInner(item)).sort((u1, u2) => u1.toString() > u2.toString() ? 1 : -1)),
    shareReplay(1)
  );
  editForm = {
    cancelTitle: this.translocoService.selectTranslate('form.cancel'),
    submitTitle: this.translocoService.selectTranslate('form.submit'),
    entityTitle: this.translocoService.selectTranslate('productParameterInner.entityTitle'),
    fields: [
      FieldConfig.create({
        type: 'input',
        label: this.translocoService.selectTranslate('productParameterInner.name'),
        inputType: 'text',
        name: 'name',
        listed: true,
        validations: [
          {
            name: 'required',
            validator: Validators.required,
            message$: this.translocoService.selectTranslate('form.required')
          }
        ]
      }),
    ]
  };

  constructor(
    protected translocoService: TranslocoService,
    private query: ProductParameterInnerQuery,
    protected store: ProductParameterInnerStore) {
    super(store, ProductParameterInner);
  }

  get resourceName(): string {
    return 'products/product-parameter-inner';
  }

}
